<div >
<mat-toolbar color="primary">
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
  <span>Dynamic Solutions</span>
  <span class="example-spacer"></span>
  <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>share</mat-icon>
  </button>
</mat-toolbar>
</div>
<div class="gridbackground">
<mat-tab-group color="accent" backgroundColor="warn">
  <mat-tab label="Mobile Applications"> 

      <!-- <mat-grid-list cols="2" >
          <mat-grid-tile> -->
            <div style="margin: 10px;">
            <div>
                <h3>Winning Team Generator</h3>
            </div>
           <div >
            <img src="./assets/cricket.png" >
          </div>
         <div>
         <a href="https://play.google.com/store/apps/details?id=io.ionic.winningTeam" style="color:white;">   <button   backgroundColor="primary" mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">    <span class="material-icons">
                arrow_downward
                </span>
                Download
              </button></a>
         </div>
         <div>
            <h2> Others Coming soon... </h2>
        </div>
      </div>
          <!-- </mat-grid-tile>
          <mat-grid-tile> <h2>Coming soon... </h2></mat-grid-tile>
        </mat-grid-list> -->



  </mat-tab>
  <mat-tab label="Mobile Games"> 
      <div style="margin: 10px;"> 
        <div>
            <h2>Eraser Game</h2>
        </div>
       <div  style="    width: 50%;">
        <img src="./assets/Eraser.png"  style="    width: 50%;  height: 50%;">
      </div>
     <div>
     <a href="https://play.google.com/store/apps/details?id=ds.dynamic.solutions" style="color:white;">   <button   backgroundColor="primary" mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">    <span class="material-icons">
            arrow_downward
            </span>
            Download
          </button></a>
     </div>
     <div>
        <h2> Others Coming soon... </h2>
    </div>
    </div>
     </mat-tab>
</mat-tab-group>
</div>
<router-outlet></router-outlet>
<div class="footer">
<mat-toolbar color="primary">
    <span>Dynamic Solutions</span>
    <span class="example-spacer"></span>
    <span>Contact: <a  style="color:white" href="dominictitusplaystore@gmail.com" >Dominictitusplaystore@gmail.com</a></span>
  </mat-toolbar>
</div>
